var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { LogFactory } from '../modules/config/logging';
import ConfigsManager from '../modules/config/configs';
import { Interval, Timer } from '../JiveSessionUtils';
import ChannelEvents from './channelEvents';
import { parseJSON, isGatewayResponse } from './utils';
import { Observable, fromEvent, merge } from 'rxjs';
var Logger = LogFactory('LifetimeChannel');
var ABNORMAL_CLOSE_CODE = 1006; // Issued when a WS fails to connect, or disconnects abnormally (including 404)
var REFRESH_CLOSE_CODE = 4000; // 	CloseEvent.code: Available for use by applications.
var LIFETIME_ELAPSED = 'Lifetime elapsed';
var KICKED_BY_NEWER_CONNECTION = 'Kicked by newer connection';
var LifetimeChannel = /** @class */ (function (_super) {
    __extends(LifetimeChannel, _super);
    function LifetimeChannel() {
        var _this = _super.call(this) || this;
        _this._webSocket = null;
        _this._reconnectTimeout = null;
        _this._disconnectTimeout = null;
        _this._pingInterval = null;
        _this._state = _this.DISCONNECTED;
        _this._correlationId = 0;
        _this._attempts = 0;
        _this._needNewUrl = false;
        _this._requests = new Map();
        _this._terminated = false;
        _this._PING_COMMAND = 'ping';
        _this._onlineStatusSubscription =
            merge(fromEvent(window, 'online'), fromEvent(window, 'offline')).subscribe(function (event) { return _this._onlineStatus(event); });
        return _this;
    }
    /**
     * Open a self-reconnecting websocket
     *
     * @param {string} origin the component that triggers the open
     */
    LifetimeChannel.prototype.open = function (origin) {
        var _this = this;
        return Observable.create(function (observer) {
            // User terminated the channel
            if (_this._terminated) {
                observer.next(undefined);
                observer.complete();
                return;
            }
            // Handling connection without network
            if (!_this._online) {
                _this._setState(_this.OFFLINE);
                observer.next(undefined);
                observer.complete();
                return;
            }
            if (!_this._url) {
                observer.error(_this.CHANNEL_NOT_CREATED);
                _this.emit(_this.ERROR, _this.CHANNEL_NOT_CREATED);
                return;
            }
            Logger.log(origin, 'is opening a new connection', _this._url);
            var disconnect = function () {
                if (!_this._online) {
                    _this._setState(_this.OFFLINE);
                    return;
                }
                _this._setState(_this.DISCONNECTED, _this.NETWORK_NOT_RESPONDING);
            };
            if (_this._disconnectTimeout) {
                _this._disconnectTimeout.stop();
            }
            _this._disconnectTimeout = new Timer(disconnect, ConfigsManager.REQUEST_TIMEOUT);
            try {
                _this._webSocket = new WebSocket(_this._url);
            }
            catch (wsEvent) {
                Logger.error('Error event', wsEvent);
                observer.error(_this.WEBSOCKET_ERROR);
                observer.complete();
                return;
            }
            // if error happens while connecting
            _this._webSocket.onerror = function (e) {
                Logger.error('Error event', e);
                observer.error(_this.WEBSOCKET_ERROR);
                observer.complete();
            };
            _this._webSocket.onopen = function (e) {
                if (_this._webSocket) {
                    // restore regular error handler
                    _this._webSocket.onerror = function (ev) { return _this._onErrorHandler(ev); };
                }
                _this._onOpenHandler();
                observer.next(undefined);
                observer.complete();
            };
            _this._webSocket.onclose = function (e) { return _this._onCloseHandler(e); };
            _this._webSocket.onmessage = function (e) { return _this._onMessageHandler(e); };
        });
    };
    LifetimeChannel.prototype._onOpenHandler = function () {
        var _this = this;
        Logger.log('Connection established');
        this._attempts = 0;
        if (this._reconnectTimeout) {
            this._reconnectTimeout.stop();
        }
        if (this._disconnectTimeout) {
            this._disconnectTimeout.stop();
        }
        if (this._pingInterval) {
            this._pingInterval.stop();
        }
        // Not the initial connection
        if (this._correlationId > 0) {
            this._setState(this.RECONNECTED);
        }
        else {
            this._setState(this.CONNECTED);
        }
        // this._requests.forEach((promise) => promise.requestTimer.resume())
        this._requests.forEach(function (promise) { return promise.requestTimer.stop(); });
        this._requests.clear();
        this._pingInterval = new Interval(function () { return _this._ping(); }, ConfigsManager.PING_INTERVAL);
    };
    LifetimeChannel.prototype._onErrorHandler = function (wsEvent) {
        Logger.error('Error event', wsEvent);
        this.emit(this.ERROR, this.WEBSOCKET_ERROR);
    };
    LifetimeChannel.prototype._onCloseHandler = function (wsEvent) {
        var _this = this;
        Logger.warn('Close event', wsEvent);
        // If channel terminated, do not attempt reconnecting
        if (this._terminated) {
            Logger.log('Terminated');
            return;
        }
        // Websocket close events are still emitted on old websockets
        if (this._webSocket && this._webSocket.readyState === 1) {
            Logger.log('Websocket close events are still emitted on old websockets');
            return;
        }
        // The WebSocket is being refreshed
        if (wsEvent.code === REFRESH_CLOSE_CODE) {
            this.open('LifetimeChannel: onClose: refresh').subscribe();
            return;
        }
        if (wsEvent.code === ABNORMAL_CLOSE_CODE) {
            Logger.warn('Channel websocket closed abnormally');
            this._needNewUrl = true;
        }
        // The WebSocket is expired by server
        if (wsEvent.reason === LIFETIME_ELAPSED) {
            this._terminated = true;
            this.emit(this.TERMINATED);
            return;
        }
        // The WebSocket is expired by server
        if (wsEvent.reason === KICKED_BY_NEWER_CONNECTION) {
            return;
        }
        this._attempts++;
        // Should we emit DISCONNECTED event on first close?
        if (this._attempts > 1) {
            this._requests.forEach(function (promise) { return promise.reject(_this.REQUEST_TIMEOUT); });
            this._requests.clear();
            this._setState(this.DISCONNECTED, this.WEBSOCKET_CLOSE);
        }
        if (this._attempts > 4) {
            this.emit(this.SERVER_DOWN);
        }
        if (this._reconnectTimeout) {
            this._reconnectTimeout.stop();
        }
        if (this._pingInterval) {
            this._pingInterval.stop();
        }
        this._startReconnectTimeout();
    };
    LifetimeChannel.prototype._startReconnectTimeout = function () {
        var _this = this;
        var delay = (this._attempts > 4 ? 30 : Math.pow(2, this._attempts)) * 1000;
        if (this._online) {
            this._reconnectTimeout = new Timer(function () { return _this._reconnect(); }, delay);
        }
    };
    LifetimeChannel.prototype._reconnect = function () {
        if (this._needNewUrl && this.refreshUrlCallback) {
            // fetch a new URL for the WS and connect to that one instead
            this.refreshUrlCallback().subscribe();
        }
        else {
            this.open('LifetimeChannel: onClose: reconnectTimeout').subscribe();
        }
    };
    LifetimeChannel.prototype._onMessageHandler = function (event) {
        try {
            var data = parseJSON(event.data);
            if (isGatewayResponse(data)) {
                if (!this._requests.has(data.correlationId)) {
                    this.emit(this.ERROR, this.UNHANDLED_MESSAGE);
                    return;
                }
                var promise = this._requests.get(data.correlationId);
                if (promise) {
                    if (data.code >= 200 && data.code < 300) {
                        promise.resolve(data.data);
                    }
                    else {
                        Logger.warn('Receiving error message', data);
                        promise.reject(data.error);
                    }
                }
                this._requests.delete(data.correlationId);
                return;
            }
            this.emit(this.MESSAGE, data);
        }
        catch (error) {
            this.emit(this.ERROR, error);
        }
    };
    LifetimeChannel.prototype._send = function (command, data) {
        var _this = this;
        this._correlationId++;
        var request = {
            correlationId: this._correlationId,
            command: command,
            data: data
        };
        return new Promise(function (resolve, reject) {
            // Network offline scenario
            if (!_this._online) {
                Logger.warn('Internet connection offline, not sending request', request);
                return reject(_this.NETWORK_OFFLINE);
            }
            // Websocket not established scenario
            if (!_this._webSocket) {
                Logger.warn('Connection not established, not sending request', request);
                _this.open('LifetimeChannel: _send: Connection not established').subscribe();
                return reject(_this.WEBSOCKET_NOT_CONNECTED);
            }
            var requestTimer;
            var timeout = function () { return reject(_this.REQUEST_TIMEOUT); };
            requestTimer = new Timer(timeout, ConfigsManager.PING_TIMEOUT);
            var promise = {
                resolve: resolve,
                reject: reject,
                command: command,
                requestTimer: requestTimer
            };
            if (_this._requests.size >= 2) {
                _this._setState(_this.DISCONNECTED, _this.NETWORK_OFFLINE);
                return;
            }
            _this._requests.set(_this._correlationId, promise);
            _this._webSocket.send(JSON.stringify(request));
        });
    };
    /**
     * Terminate channel
     */
    LifetimeChannel.prototype.terminate = function () {
        Logger.log("Terminating channel");
        this._terminated = true;
        this.removeAllListeners();
        this._onlineStatusSubscription.unsubscribe();
        if (this._pingInterval) {
            this._pingInterval.stop();
            this._pingInterval = null;
        }
        if (this._disconnectTimeout) {
            this._disconnectTimeout.stop();
            this._disconnectTimeout = null;
        }
        if (this._reconnectTimeout) {
            this._reconnectTimeout.stop();
            this._reconnectTimeout = null;
        }
        this._requests.forEach(function (promise) { return promise.requestTimer.stop(); });
        this._requests.clear();
        if (!this._webSocket) {
            return;
        }
        try {
            this._webSocket.close(1000); // The connection successfully completed for the purpose for which it was created.
            this._webSocket = null;
        }
        catch (error) {
            Logger.error('Error closing websocket', error);
        }
    };
    /**
     * Refresh (optionnaly close then open) socket connection
     */
    LifetimeChannel.prototype.refresh = function () {
        if (this._webSocket) {
            if (this._webSocket.readyState === this._webSocket.CLOSED) { // WebSocket is already close
                this.open('LifetimeChannel: refresh: WS is already closed').subscribe();
            }
            else {
                this._webSocket.close(REFRESH_CLOSE_CODE);
            }
        }
    };
    LifetimeChannel.prototype._onlineStatus = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            return __generator(this, function (_a) {
                Logger.log('Network condition', event.type);
                if (this._requests) {
                    // this._requests.forEach((promise) => promise.requestTimer.stop())
                    this._requests.clear();
                }
                if (event.type !== 'online') {
                    if (this._pingInterval) {
                        this._pingInterval.stop();
                    }
                    this._setState(this.DISCONNECTED, this.NETWORK_OFFLINE);
                    return [2 /*return*/];
                }
                this._setState(this.ONLINE);
                if (!this._webSocket) {
                    this.emit(this.ERROR, this.WEBSOCKET_NOT_CONNECTED);
                }
                if (this._pingInterval) {
                    this._pingInterval.stop();
                }
                this._ping();
                this._pingInterval = new Interval(function () { return _this._ping(); }, ConfigsManager.PING_INTERVAL);
                return [2 /*return*/];
            });
        });
    };
    LifetimeChannel.prototype._ping = function () {
        return __awaiter(this, void 0, void 0, function () {
            var error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this._online) {
                            this._setState(this.OFFLINE);
                            return [2 /*return*/];
                        }
                        if (this._webSocket && this._webSocket.readyState !== 1) {
                            return [2 /*return*/];
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, this._send(this._PING_COMMAND)];
                    case 2:
                        _a.sent();
                        this._setState(this.CONNECTED);
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        Logger.error('Ping error', error_1);
                        this._setState(this.DISCONNECTED, error_1);
                        if (this._pingInterval) {
                            this._pingInterval.stop();
                        }
                        this._requests.clear();
                        this.open('LifetimeChannel: Ping: error').subscribe();
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(LifetimeChannel.prototype, "url", {
        set: function (url) {
            var _this = this;
            Logger.log('Setting new url and refreshing the WS.');
            this._url = url;
            if (this._webSocket) {
                if (this._reconnectTimeout) {
                    this._reconnectTimeout.stop();
                }
                if (this._pingInterval) {
                    this._pingInterval.stop();
                }
                this._requests.forEach(function (promise) { return promise.reject(_this.REQUEST_TIMEOUT); });
                this._requests.clear();
            }
            this.refresh();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LifetimeChannel.prototype, "_online", {
        get: function () {
            return navigator.onLine;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(LifetimeChannel.prototype, "state", {
        get: function () {
            return this._state;
        },
        enumerable: true,
        configurable: true
    });
    LifetimeChannel.prototype._setState = function (state, error) {
        if (state !== this.state) {
            this._state = state;
            this.emit(this.state, error ? error : null);
        }
    };
    return LifetimeChannel;
}(ChannelEvents));
export default LifetimeChannel;
//# sourceMappingURL=lifetimeChannel.js.map